import { connect, FormikValues } from 'formik'
import { cloneDeep } from 'lodash'
import { IntlShape, useIntl } from 'react-intl'
import styled from 'styled-components'
import { string } from 'yup'

import Label from '@/components/Label'
import { FormLabel, Row } from '@/components/StyledComponents'
import { VariableInputContainer } from '@/pages/SpaceAppBuilder/components/StyledComponents'
import VariableInput from '@/pages/SpaceAppBuilder/components/VariableInput/VariableInput'
import { useWorkflowFeature } from '@/pages/SpaceAppBuilder/FeaturesPage/WorkflowFeatureContext'
import convertJSONtoSchema from '@/pages/SpaceAppBuilder/utilities/convertJSONToSchema'
import { FieldTypes, RagPromptStepData, StepData } from '@/pages/SpaceAppBuilder/utilities/interfaces'

import messages from './messages'

const StyledRow = styled(Row)`
  justify-content: flex-start;
  margin-bottom: 5px;
`

type RagPromptProps = {
  readOnly?: boolean
}

const getValidationSchema = (intl: IntlShape) => {
  return {
    knnChunks: string().required(intl.formatMessage(messages.contentRequired)),
    question: string().required(intl.formatMessage(messages.questionRequired))
  }
}

const getInitialValues = (stepData: RagPromptStepData): StepData => {
  return {
    knnChunks: stepData.knnChunks ?? '',
    question: stepData.question ?? ''
  }
}

const getNetworkRequestObject = (data: { triggerData: any; stepData: any }) => {
  const updatedValues: any = cloneDeep(data)
  const outputJson = { answer: '' }

  updatedValues.output = convertJSONtoSchema(outputJson)
  return updatedValues
}

const RagPromptOperation = ({ readOnly = false }: RagPromptProps & FormikValues) => {
  const intl = useIntl()

  const { getVariablesForStep } = useWorkflowFeature()
  const variables = getVariablesForStep()

  return variables?.length > 0 ? (
    <>
      <Label className="mt-4" required>
        {intl.formatMessage(messages.content)}
      </Label>
      <Label className="text-sm text-gray-600">{intl.formatMessage(messages.contentSubtitle)}</Label>
      <VariableInputContainer>
        <VariableInput
          name={'stepData.knnChunks'}
          multiline={true}
          placeholder={intl.formatMessage(messages.enterContent)}
          variables={variables}
          validVariableTypes={[FieldTypes.ARRAY, FieldTypes.STRING, FieldTypes.ANY]}
          readOnly={readOnly}
        />
      </VariableInputContainer>
      <Label className="mt-4" required>
        {intl.formatMessage(messages.question)}
      </Label>
      <Label className="text-sm text-gray-600">{intl.formatMessage(messages.ragQuestionSubtitle)}</Label>
      <VariableInputContainer>
        <VariableInput
          name={'stepData.question'}
          multiline={true}
          placeholder={intl.formatMessage(messages.enterQuestion)}
          variables={variables}
          validVariableTypes={[
            FieldTypes.STRING,
            FieldTypes.INTEGER,
            FieldTypes.NUMBER,
            FieldTypes.BOOLEAN,
            FieldTypes.ANY
          ]}
          required={false}
          readOnly={readOnly}
        />
      </VariableInputContainer>
    </>
  ) : (
    <StyledRow>
      <FormLabel>{intl.formatMessage(messages.arrayVariableErrorMessage)}</FormLabel>
    </StyledRow>
  )
}

export default connect(RagPromptOperation)

export { getInitialValues, getValidationSchema, getNetworkRequestObject }
